(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('Integration', Integration);

    Integration.$inject = ['$resource'];

    function Integration ($resource) {
        var resourceUrl =  'api/integrations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'verifySSO': { url: 'api/sso/:accessKey', method: 'GET' },
            'authorizeGrantRequest': { url: 'api/integration-grant-request/authorize/:token', method: 'GET' }
        });
    }
})();
